import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Footer from './footer.js';
import {
    cacheProjects,
    fetchProjects,
    getProjectId,
    readCachedProjects
} from './interactive_data.js';

const Interactive = () => {
    const [imgs, setImgs] = useState(() => readCachedProjects());

    async function loadList() {
        try {
            const data = await fetchProjects();
            cacheProjects(data);
            setImgs(data);
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        if (imgs === null) {
            loadList();
        } else {
            console.log('lista de imágenes cargada');
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="container">
            {
                imgs === null
                ?
                <div className="load_screen2">CARGANDO...</div>
                :
                <div>
                    <div className="title">
                        <h1 className="section_titles">Tecnología y Software</h1>
                    </div>

                    <div className="main_list" id="motion_list">
                        {imgs.map((img, index) => (
                            <div className="pro_main" key={getProjectId(img) || index}>
                                <div className="pro_margin">
                                    <Link
                                        className="pro_image_link"
                                        to={`/project/${getProjectId(img)}`}
                                        aria-label={`Ver ${img.name}`}
                                    >
                                        <img className="pro_image2" src={img.link} alt={img.name}/>
                                    </Link>
                                    <p className="pro_title">{img.name}</p>
                                    <p className="pro_client">Cliente: {img.client}</p>
                                </div>
                            </div>
                        ))}
                        <div className="clear"></div>
                    </div>
                    <Footer/>
                </div>
            }
        </div>
    );
};

export default Interactive;
